<!-- רשימה של סרטונים -->
<div class="container">
    <div class="row align-items-around justify-content-around">
        <ng-container *ngFor="let video of videos; let i = index">
            <ng-container *ngIf="(i +rand) % 7 === 0">
                <advertisment
                 *ngIf="(46375==userId)"
                    class="video_card col-11 col-sm-6 col-md-4 col-lg-4 col-xl-3 col-xxl-2-3">
                </advertisment>
                <video-card (removedFromFavorites)="removeVideo($event)"
                    class="video_card col-11 col-sm-6 col-md-4 col-lg-4 col-xl-3 col-xxl-2-3"
                    [video]="video"></video-card>

            </ng-container>
            <ng-container *ngIf="(i + rand) % 7 !== 0">
                <video-card (removedFromFavorites)="removeVideo($event)"
                    class="video_card col-11 col-sm-6 col-md-4 col-lg-4 col-xl-3 col-xxl-2-3"
                    [video]="video"></video-card>
            </ng-container>
        </ng-container>
    </div>
</div>
